import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const FILING_BATCH_ADD_ACCOUNTS_HELP: HelpContent[] = [
    {
        helpContentId: 'filing-batch-add-accounts.panel',
        tooltipText: 'List of filings that are available to add to this batch.  The filing must be in the same top-level company, state and tax year as this batch.  In addition, the filing must not be in another batch or already filed.',
        hasIcon: true
    }
];
